import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from './ui/button';

const YearSelector = ({ currentYear, onChange }) => {
  const handlePrevYear = () => {
    onChange(currentYear - 1);
  };

  const handleNextYear = () => {
    onChange(currentYear + 1);
  };

  const isCurrentYear = currentYear === new Date().getFullYear();

  return (
    <div className="flex items-center gap-2 bg-white border border-slate-200 rounded-lg p-2 shadow-sm">
      <Button
        onClick={handlePrevYear}
        variant="ghost"
        size="sm"
        className="h-8 w-8 p-0"
      >
        <ChevronLeft className="h-4 w-4" />
      </Button>
      
      <div className={`
        px-4 py-1 rounded font-semibold min-w-[100px] text-center
        ${isCurrentYear 
          ? 'bg-blue-100 text-blue-700' 
          : 'bg-slate-100 text-slate-700'
        }
      `}>
        {currentYear}
        {isCurrentYear && <span className="ml-1 text-xs">(corrente)</span>}
      </div>
      
      <Button
        onClick={handleNextYear}
        variant="ghost"
        size="sm"
        className="h-8 w-8 p-0"
      >
        <ChevronRight className="h-4 w-4" />
      </Button>
    </div>
  );
};

export default YearSelector;
